/**
 * View split left and right parts, default 50% 50% relation
 *
 */
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
const useRightStyles = makeThemedStyles("Right", (theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
}));
const Right = (
  props: React.PropsWithChildren<{
    gap?: string;
  }>
) => {
  const styles = useRightStyles();
  return (
    <div
      className={styles.root}
      style={{
        gap: props.gap,
      }}
    >
      {props.children}
    </div>
  );
};

export default Right;
